/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { colors, mixins } from '@blend/consumer-components';
import { formatTime } from '@utils/formatting';

export namespace EventItem {
  export interface Props {
    id: string;
    actor: string;
    action: string;
    description?: string;
    target: string;
    occurredAt: string;
  }
}

const styles = StyleSheet.create({
  wrapper: {
    ...mixins.borderBottom(1, 'solid', mixins.globalBorderColor),
    ':first-child': {
      marginTop: 0,
    },
    ':last-child': {
      marginBottom: 0,
    },
  },
  event: {
    color: colors.catalyst,
    ...mixins.marginVertical(12),
  },
  eventText: {
    fontSize: 14,
    marginTop: 12,
  },
  actor: { fontWeight: 'bold' },
  action: {},
  description: { marginTop: 12 },
  target: { fontWeight: 'bold' },
  timestamp: {
    fontWeight: 'bold',
    fontSize: 10,
    color: colors.catalystLight40,
  },
});

export const EventItem: React.FC<EventItem.Props> = ({ actor, action, description, target, occurredAt }) => (
  <div className={css(styles.wrapper)} data-it="Event">
    <div className={css(styles.event)}>
      <div className={css(styles.timestamp)}>{formatTime(occurredAt)}</div>
      <div className={css(styles.eventText)}>
        <span className={css(styles.actor)}>{actor}</span>
        <span data-it="eventItem-action" className={css(styles.action)}>
          {' '}
          {action}
        </span>
        {description && <div className={css(styles.description)}> {description}</div>}
        {target.length > 0 && <span className={css(styles.target)}> {target}</span>}
      </div>
    </div>
  </div>
);
